/**
 * Comprehensive list of Canadian universities and colleges.
 * Used for autocomplete/typeahead in the Education section.
 * Includes an "Other" option for institutions not in the list.
 */

const CANADIAN_INSTITUTIONS: string[] = [
  // ── Universities ──────────────────────────────────────────

  // Alberta
  'Athabasca University',
  'Concordia University of Edmonton',
  'MacEwan University',
  'Mount Royal University',
  'The King\'s University',
  'University of Alberta',
  'University of Calgary',
  'University of Lethbridge',

  // British Columbia
  'Capilano University',
  'Emily Carr University of Art + Design',
  'Kwantlen Polytechnic University',
  'Royal Roads University',
  'Simon Fraser University',
  'Thompson Rivers University',
  'Trinity Western University',
  'University of British Columbia',
  'University of Northern British Columbia',
  'University of the Fraser Valley',
  'University of Victoria',
  'Vancouver Island University',

  // Manitoba
  'Brandon University',
  'Canadian Mennonite University',
  'University of Manitoba',
  'University of Winnipeg',

  // New Brunswick
  'Mount Allison University',
  'St. Thomas University',
  'Université de Moncton',
  'University of New Brunswick',

  // Newfoundland and Labrador
  'Memorial University of Newfoundland',

  // Nova Scotia
  'Acadia University',
  'Cape Breton University',
  'Dalhousie University',
  'Mount Saint Vincent University',
  'Nova Scotia College of Art and Design University (NSCAD)',
  'Saint Mary\'s University',
  'St. Francis Xavier University',
  'Université Sainte-Anne',
  'University of King\'s College',

  // Ontario
  'Algoma University',
  'Brock University',
  'Carleton University',
  'Lakehead University',
  'Laurentian University',
  'McMaster University',
  'Nipissing University',
  'OCAD University',
  'Ontario Tech University',
  'Queen\'s University',
  'Royal Military College of Canada',
  'Toronto Metropolitan University',
  'Trent University',
  'University of Guelph',
  'University of Ottawa',
  'University of Toronto',
  'University of Waterloo',
  'University of Western Ontario',
  'University of Windsor',
  'Wilfrid Laurier University',
  'York University',

  // Prince Edward Island
  'University of Prince Edward Island',

  // Quebec
  'Bishop\'s University',
  'Concordia University',
  'École de technologie supérieure (ÉTS)',
  'École nationale d\'administration publique (ENAP)',
  'École Polytechnique de Montréal',
  'HEC Montréal',
  'Institut national de la recherche scientifique (INRS)',
  'McGill University',
  'Université de Montréal',
  'Université de Sherbrooke',
  'Université du Québec',
  'Université du Québec à Chicoutimi (UQAC)',
  'Université du Québec à Montréal (UQAM)',
  'Université du Québec à Rimouski (UQAR)',
  'Université du Québec à Trois-Rivières (UQTR)',
  'Université du Québec en Abitibi-Témiscamingue (UQAT)',
  'Université du Québec en Outaouais (UQO)',
  'Université Laval',
  'Université TÉLUQ',

  // Saskatchewan
  'First Nations University of Canada',
  'University of Regina',
  'University of Saskatchewan',

  // ── Colleges & Polytechnics ───────────────────────────────

  // Alberta
  'Bow Valley College',
  'Keyano College',
  'Lakeland College',
  'Lethbridge College',
  'Medicine Hat College',
  'NorQuest College',
  'Northern Alberta Institute of Technology (NAIT)',
  'Northern Lakes College',
  'Olds College',
  'Portage College',
  'Red Deer Polytechnic',
  'Southern Alberta Institute of Technology (SAIT)',

  // British Columbia
  'British Columbia Institute of Technology (BCIT)',
  'Camosun College',
  'College of New Caledonia',
  'College of the Rockies',
  'Douglas College',
  'Justice Institute of British Columbia',
  'Langara College',
  'North Island College',
  'Northern Lights College',
  'Okanagan College',
  'Selkirk College',

  // Manitoba
  'Assiniboine Community College',
  'Red River College Polytechnic',
  'University College of the North',

  // New Brunswick
  'New Brunswick Community College (NBCC)',
  'Collège communautaire du Nouveau-Brunswick (CCNB)',

  // Newfoundland and Labrador
  'College of the North Atlantic',

  // Northwest Territories
  'Aurora College',

  // Nova Scotia
  'Nova Scotia Community College (NSCC)',

  // Nunavut
  'Nunavut Arctic College',

  // Ontario
  'Algonquin College',
  'Cambrian College',
  'Canadore College',
  'Centennial College',
  'Collège Boréal',
  'Collège La Cité',
  'Conestoga College',
  'Confederation College',
  'Durham College',
  'Fanshawe College',
  'Fleming College',
  'George Brown College',
  'Georgian College',
  'Humber College',
  'Lambton College',
  'Loyalist College',
  'Mohawk College',
  'Niagara College',
  'Northern College',
  'Sault College',
  'Seneca Polytechnic',
  'Sheridan College',
  'St. Clair College',
  'St. Lawrence College',

  // Prince Edward Island
  'Holland College',

  // Quebec (CEGEPs & Colleges)
  'Cégep de la Gaspésie et des Îles',
  'Cégep de Sherbrooke',
  'Cégep du Vieux Montréal',
  'Cégep Limoilou',
  'Cégep de Sainte-Foy',
  'Cégep de Saint-Laurent',
  'Cégep de Trois-Rivières',
  'Cégep Édouard-Montpetit',
  'Cégep Marie-Victorin',
  'Champlain Regional College',
  'Collège Ahuntsic',
  'Collège André-Grasset',
  'Collège de Bois-de-Boulogne',
  'Collège de Maisonneuve',
  'Collège de Rosemont',
  'Collège de Valleyfield',
  'Collège Dawson',
  'Collège John Abbott',
  'Collège Lionel-Groulx',
  'Collège Montmorency',
  'Collège Vanier',
  'Dawson College',
  'Heritage College',
  'John Abbott College',
  'Marianopolis College',
  'Vanier College',

  // Saskatchewan
  'Saskatchewan Polytechnic',

  // Yukon
  'Yukon University',

  // ── "Other" for unlisted institutions ─────────────────────
  'Other',
];

// Sort alphabetically but keep "Other" at the end
CANADIAN_INSTITUTIONS.sort((a, b) => {
  if (a === 'Other') return 1;
  if (b === 'Other') return -1;
  return a.localeCompare(b);
});

export default CANADIAN_INSTITUTIONS;
